﻿$.fn.dxCtrlContentEnvoiMailingRgpd = function custom_dxCtrlContentEnvoiMailingRgpd(option) {
    if (option == "instance") {
        return this.instance;
    }
    else {
        this.addClass("dx-dxctrlcontentenvoimailingrgpd dx-ctrl");
        this.createInstance(new cdxCtrlContentEnvoiMailingRgpd(this, option));
    }
    return this;
}

window.cdxCtrlContentEnvoiMailingRgpd = function (container, option) {
    var Me = this;

    this.option = function (name, value) {
        if (typeof value == 'undefined') {
            return option[name];
        }
        else {
            option[name] = value;
        }
    }

    var jauge = null
    var Html = null
    function mConstruit() {
        container.empty()
        container.css("text-align", "left")
        container.css("height", container.innerHeight() + "px")

        option.bddCtrl.mAjaxCall({
            command: "gethtmlurldataemailbdd",
            nom_table: option.bddCtrl.getObjet(option.data).mGetTable().nom,
            id: option.bddCtrl.getObjet(option.data).cle()
        }, function (data) {
            html = data.html
            mRempli()
        },function () {
            container.css("height", "")
        })
    }

    function mRempli() {
        container.empty()
        var $Div = $(html)

        $("<div style='margin:10px 0;'/>").appendTo(container).dxCheckBox({
            text: "Ce mail n'est pas un email commercial",
            value: (option.data.rgpd_is_email_commercial == "0"),
            onValueChanged: function (e) {
                option.data.rgpd_is_email_commercial = (e.value ? "0" : "1")
                option.bddCtrl.getObjet(option.data).mSaveChamp("rgpd_is_email_commercial")
                mRempli()
                if (option.onChange) option.onChange()
            }
        })

        if (option.data.rgpd_is_email_commercial == "1") {
            var rgpd = new cRgpd({ html: html, data: option.data })
            var $DivDetail = $("<div style='padding-left:30px;'/>").appendTo(container)

            var $DivContainer = $("<div style='margin-top:15px;'/>").appendTo($DivDetail)
            if (!rgpd.hasLienDesinscription()) {
                //pas de lien de désinscription
                var color = "green"
                if (option.data.rgpd_gere_lien_desinscription == "1") {
                    $("<span><i class='fas fa-thumbs-up' style='color:green'></i></span>").appendTo($DivContainer)
                } else {
                    $("<span><i class='fas fa-thumbs-down' style='color:red'></i></span>").appendTo($DivContainer)
                    color = "red"
                }
                $("<span style='color:" + color + "'>&nbsp;Votre email ne dispose pas de <b>lien de désinscription</b>.</span>").appendTo($DivContainer)
                $("<br/>").appendTo($DivContainer)
                $("<div/>").appendTo($DivContainer).dxCheckBox({
                    text: "Je gère moi-même le lien de désinscription",
                    value: (option.data.rgpd_gere_lien_desinscription == "1"),
                    onValueChanged: function (e) {
                        option.data.rgpd_gere_lien_desinscription = (e.value ? "1" : "0")
                        option.bddCtrl.getObjet(option.data).mSaveChamp("rgpd_gere_lien_desinscription")
                        mRempli()
                        if (option.onChange) option.onChange()
                    }
                })
            } else {
                $("<span><i class='fas fa-thumbs-up' style='color:green'></i></span>").appendTo($DivContainer)
                $("<span style='color:green'>&nbsp;Votre email propose un <b>lien de désinscription</b>.</span>").appendTo($DivContainer)
            }

            var $DivContainer = $("<div style='margin-top:15px;'/>").appendTo($DivDetail)
            if (!rgpd.hasLienPixelTracking()) {
                //pas de lien pixel tracking
                var color = "green"
                if (option.data.rgpd_gere_lien_pixel_suivi == "1") {
                    $("<span><i class='fas fa-thumbs-up' style='color:green'></i></span>").appendTo($DivContainer)
                } else {
                    $("<span><i class='fas fa-thumbs-down' style='color:red'></i></span>").appendTo($DivContainer)
                    color = "red"
                }
                $("<span style='color:" + color + "'>&nbsp;Votre email ne dispose pas d'un <b>lien pour la désactivation du pixel de tracking</b>.</span>").appendTo($DivContainer)
                $("<br/>").appendTo($DivContainer)
                $("<div/>").appendTo($DivContainer).dxCheckBox({
                    text: "Je gère moi-même le lien de désactivation du pixel de tracking",
                    value: (option.data.rgpd_gere_lien_pixel_suivi == "1"),
                    onValueChanged: function (e) {
                        option.data.rgpd_gere_lien_pixel_suivi = (e.value ? "1" : "0")
                        option.bddCtrl.getObjet(option.data).mSaveChamp("rgpd_gere_lien_pixel_suivi")
                        mRempli()
                        if (option.onChange) option.onChange()
                    }
                })
            } else {
                $("<span><i class='fas fa-thumbs-up' style='color:green'></i></span>").appendTo($DivContainer)
                $("<span style='color:green'>&nbsp;Votre email propose un <b>lien de désactivation du pixel de tracking</b>.</span>").appendTo($DivContainer)
            }


            var $DivContainer = $("<div style='margin-top:15px;'/>").appendTo($DivDetail)
            if (!rgpd.hasChampNomSociete()) {
                //pas de champ nom societe
                var color = "green"
                if (option.data.rgpd_gere_champ_societe == "1") {
                    $("<span><i class='fas fa-thumbs-up' style='color:green'></i></span>").appendTo($DivContainer)
                } else {
                    $("<span><i class='fas fa-thumbs-down' style='color:red'></i></span>").appendTo($DivContainer)
                    color = "red"
                }
                $("<span style='color:" + color + "'>&nbsp;Votre email ne dispose pas d'un champ précisant la <b>société expéditeur de votre message</b>.</span>").appendTo($DivContainer)
                $("<br/>").appendTo($DivContainer)
                $("<div/>").appendTo($DivContainer).dxCheckBox({
                    text: "Je gère moi-même le champ de la société expéditrice",
                    value: (option.data.rgpd_gere_champ_societe == "1"),
                    onValueChanged: function (e) {
                        option.data.rgpd_gere_champ_societe = (e.value ? "1" : "0")
                        option.bddCtrl.getObjet(option.data).mSaveChamp("rgpd_gere_champ_societe")
                        mRempli()
                        if (option.onChange) option.onChange()
                    }
                })
            } else {
                $("<span><i class='fas fa-thumbs-up' style='color:green'></i></span>").appendTo($DivContainer)
                $("<span style='color:green'>&nbsp;Votre email dispose d'un champ précisant la <b>société expéditeur de votre message</b>.</span>").appendTo($DivContainer)
            }

            var $DivContainer = $("<div style='margin-top:15px;'/>").appendTo($DivDetail)
            if (!rgpd.hasLienPolitiqueConf()) {
                //pas de lien politique conf
                var color = "green"
                if (option.data.rgpd_gere_lien_politique_conf == "1") {
                    $("<span><i class='fas fa-thumbs-up' style='color:green'></i></span>").appendTo($DivContainer)
                } else {
                    $("<span><i class='fas fa-thumbs-down' style='color:red'></i></span>").appendTo($DivContainer)
                    color = "red"
                }
                $("<span style='color:" + color + "'>&nbsp;Votre email ne dispose pas d'un lien sur votre <b>politique de confidentialité</b>.</span>").appendTo($DivContainer)
                $("<br/>").appendTo($DivContainer)
                $("<div/>").appendTo($DivContainer).dxCheckBox({
                    text: "Je gère moi-même le lien sur ma politique de confidentialité",
                    value: (option.data.rgpd_gere_lien_politique_conf == "1"),
                    onValueChanged: function (e) {
                        option.data.rgpd_gere_lien_politique_conf = (e.value ? "1" : "0")
                        option.bddCtrl.getObjet(option.data).mSaveChamp("rgpd_gere_lien_politique_conf")
                        mRempli()
                        if (option.onChange) option.onChange()
                    }
                })
            } else {
                $("<span><i class='fas fa-thumbs-up' style='color:green'></i></span>").appendTo($DivContainer)
                $("<span style='color:green'>&nbsp;Votre email propose un lien sur votre <b>politique de confidentialité</b>.</span>").appendTo($DivContainer)
            }


            var $DivContainer = $("<div style='margin-top:15px;'/>").appendTo($DivDetail)
            if (!rgpd.hasChampSourceEmail()) {
                //pas de champ source email
                var color = "green"
                if (option.data.rgpd_gere_champ_source_email == "1") {
                    $("<span><i class='fas fa-thumbs-up' style='color:green'></i></span>").appendTo($DivContainer)
                } else {
                    $("<span><i class='fas fa-thumbs-down' style='color:red'></i></span>").appendTo($DivContainer)
                    color = "red"
                }
                $("<span style='color:" + color + "'>&nbsp;Votre email ne dispose pas d'un champ précisant la <b>source de l'adresse email destinataire</b>.</span>").appendTo($DivContainer)
                $("<br/>").appendTo($DivContainer)
                $("<div/>").appendTo($DivContainer).dxCheckBox({
                    text: "Je gère moi-même le champ de la société expéditrice",
                    value: (option.data.rgpd_gere_champ_source_email == "1"),
                    onValueChanged: function (e) {
                        option.data.rgpd_gere_champ_source_email = (e.value ? "1" : "0")
                        option.bddCtrl.getObjet(option.data).mSaveChamp("rgpd_gere_champ_source_email")
                        mRempli()
                        if (option.onChange) option.onChange()
                    }
                })
            } else {
                $("<span><i class='fas fa-thumbs-up' style='color:green'></i></span>").appendTo($DivContainer)
                $("<span style='color:green'>&nbsp;Votre email dispose d'un champ précisant la <b>source de l'adresse email destinataire</b>.</span>").appendTo($DivContainer)
            }
        }
    }

    this.mUpdate = function () {
        mConstruit()
    }

    this.element = function () { return container }

    mConstruit();
}